import { APIPost, APIUrl, AdminType } from "api/protocols";

export type TExchangeSettlementType = "refund" | "even" | "collect";

export interface IExchangeReturnItem {
  line_item_id: number;
  quantity: number;
}

export interface IExchangeReplacementItem {
  variant_id: number;
  quantity: number;
  price: number;
}

export interface IExchangeGroup {
  return_items: IExchangeReturnItem[];
  exchange_items: IExchangeReplacementItem[];
}

export interface IExchangeCalculateLineTax {
  tax_line_id?: number;
  title?: string;
  rate?: number;
  price: number;
}

export interface IExchangeCalculateReturnLineItem {
  quantity: number;
  line_item_id: number;
  price: number;
  subtotal: number;
  total_tax: number;
  total_price: number;
  tax_lines: IExchangeCalculateLineTax[];
}

export interface IExchangeCalculateReplacementLineItem {
  variant_id: number;
  quantity: number;
  price: number;
  subtotal: number;
  total_tax: number;
  total_price: number;
  tax_lines: IExchangeCalculateLineTax[];
}

export interface IExchangeSuggestedRefundTransaction {
  order_id: number;
  kind: string;
  parent_id: number;
  amount: number;
  currency: string;
  maximum_refundable: number;
}

export interface IPostCalculateExchange {
  order_id: number;
  exchanges: IExchangeGroup[];
}

export interface IExchangeCalculateResponse {
  order_id: number;
  currency: string;
  settlement_type: TExchangeSettlementType;
  return_subtotal: number;
  return_tax: number;
  return_total: number;
  exchange_subtotal: number;
  exchange_tax: number;
  exchange_total: number;
  net_balance: number;
  amount_due: number;
  return_line_items: IExchangeCalculateReturnLineItem[];
  exchange_line_items: IExchangeCalculateReplacementLineItem[];
  tax_lines: IExchangeCalculateLineTax[];
  refund_transactions: IExchangeSuggestedRefundTransaction[];
}

export async function PostCalculateExchange(params: IPostCalculateExchange, useGlobalLoader: boolean) {
  return await APIPost<IExchangeCalculateResponse>(
    APIUrl(AdminType.FacilityAdmin, "/order/exchange/calculate"),
    params,
    useGlobalLoader,
  );
}

export interface IExchangeRefundTransaction {
  parent_id: number;
  amount: number;
}

export interface IExchangePaymentTransaction {
  transaction_id?: number;
  amount: number;
  payment_method?: string;
  payment_option_id?: number;
  gift_card_code?: string;
  account_id?: number;
  credit_book_id?: number;
}

export interface IPostExchange {
  order_id: number;
  exchanges: IExchangeGroup[];
  net_balance?: number;
  note?: string;
  refund_transactions?: IExchangeRefundTransaction[];
  payment_transactions?: IExchangePaymentTransaction[];
}

export async function PostExchange(params: IPostExchange, useGlobalLoader: boolean) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/order/exchange"), params, useGlobalLoader);
}
